import i18n from "../i18n";

const MealPlanLibrary = (app) => {
  app
    .post("/meal-plan-library/save/:id?", async ({ api, flash, req, res }) => {
      const { body, files, params } = req;
      if (params.id) {
        delete body.file;
        const response = await api(`meal-plan-library/${params.id}`, {
          method: "PUT",
          body,
          files,
        });
        const updated = await response.json();

        // Redirect only when switching detailed→simplified (backend created new MealPlan)
        const mealPlan =
          typeof body.mealPlan === "string"
            ? JSON.parse(body.mealPlan || "{}")
            : body.mealPlan || {};
        const mealPlanIdChanged =
          mealPlan.planMode === "simplified" &&
          updated?.mealPlan?.mealPlanId &&
          String(updated.mealPlan.mealPlanId) !==
            String(mealPlan.mealPlanId ?? "");
        if (body.widget && mealPlanIdChanged) {
          flash("success", "Successfully saved");
          return res.redirect(
            `/coaching-portal/templates/edit-meal-plan?mealPlan=${updated.mealPlan.mealPlanId}&widget=${body.widget}&planMode=simplified`
          );
        }
      } else {
        await api("meal-plan-library", {
          method: "POST",
          body,
          files,
        });
      }

      flash(
        "success",
        i18n.t("coaching-portal:mealPlanLibraryActions.successfullySaved")
      );

      res.refreshWith(
        { modal: "", file: "", selectedMealPlanLibraryId: "", submited: true },
        { url: "back", hash: "#_" }
      );
    })
    .get("/meal-plan-library/delete/:id", async ({ api, flash, req, res }) => {
      const { id } = req.params;

      await api(`meal-plan-library/${id}`, {
        method: "DELETE",
      });

      flash(
        "success",
        i18n.t("coaching-portal:mealPlanLibraryActions.successfullyRemoved")
      );

      res.backDontScroll();
    })
    .post(
      "/meal-plan-library/reorder",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        assert(
          body.orderedMealPlans,
          400,
          i18n.t("coaching-portal:mealPlanLibraryActions.provideOrderArray")
        );

        await api("meal-plan-library-reorder", {
          method: "PUT",
          body,
        });

        flash(
          "success",
          i18n.t("coaching-portal:mealPlanLibraryActions.successfullyReordered")
        );
        res.backDontScroll();
      }
    )
    .post(
      "/meal-plan-library/status/:id",
      async ({ api, assert, flash, req, res }) => {
        const {
          body: { status, fileId },
          params: { id },
        } = req;
        const verbs = {
          draft: "unpublish",
          published: "publish",
        };

        assert(
          status,
          400,
          i18n.t("coaching-portal:mealPlanLibraryActions.statusRequired")
        );
        assert(
          id,
          400,
          i18n.t("coaching-portal:mealPlanLibraryActions.idRequired")
        );

        const verb = verbs[status];

        await api(`meal-plan-library/${id}`, {
          method: "PUT",
          body: { status, fileId },
        });

        flash(
          "success",
          verb === "publish"
            ? i18n.t(
                "coaching-portal:mealPlanLibraryActions.successfullyPublished"
              )
            : i18n.t(
                "coaching-portal:mealPlanLibraryActions.successfullyUnpublished"
              )
        );

        res.backDontScroll();
      }
    );
};

export default MealPlanLibrary;
